import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import { AudioCategorySelectorNew } from '../../components/menus/AudioCategorySelectorNew';
import { SoundItemRenderer } from '../../components/menus/SoundItemRenderer';
import { expandAudioList } from '../../actions/MenuActions';
import { changeMusicContentIndex } from '../../actions/MusicActions';
import { setMediaFilesDataProvider } from '../../actions/AccordionActions';
import locales from '../../locales/LocalesManager';
import configuration from '../../constants/Configuration';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import mouseUtils from '../../components/utils/MouseUtils';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import hoverManager from '../utils/HoverManager';
import platformDetection from '../utils/PlatformDetection';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                this.props.dispatch(changeMusicContentIndex(0));
                break;
            }

            case 1: {
                this.props.dispatch(changeMusicContentIndex(1));
                break;
            }
        }

        this.props.dispatch(expandAudioList(false, this.props.type));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.category != newProps.category || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;
        var mySoundsSelected = false;

        if (this.props.category == 1)
            mySoundsSelected = true;

        if (this.props.index == 0) { // Music button
            if (mySoundsSelected == false) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = '#D7D7D7';
                }
            }

        } else { // My Sounds button
            if (mySoundsSelected == true) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = '#D7D7D7';
                }
            }
        }

        var topPosition = 0;
        var left = this.props.index == 0 ? 0 : this.props.accordionWidth / 2;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth / 2 - 2,
            height: properties.BROWSER_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            left: left,
            top: topPosition,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#FFFFFF',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 15,
            position: 'absolute',
            width: buttonStyle.width - 2 * 5,
            left: 5,
            top: 6,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center'
        };

        var text = this.props.text;

        if (this.props.index == 0) {
            text = locales.getCaption('MusicContent', 'music');
        } else {
            text = locales.getCaption('MySoundsContent', 'music');
        }

        return (
            <button aria-label={text} style={buttonStyle} onClick={this.onClick} onTouchStart={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

const AudioList = React.createClass({
    getInitialState() {
        return {
            elements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps: function(nextProps) {
        var currentItem;
        var nextItem;

        if (this.props.dataProvider[0])
            currentItem = this.props.dataProvider[0].title;

        if (nextProps.dataProvider[0])
            nextItem = nextProps.dataProvider[0].title;

        if (currentItem != nextItem || this.props.accordionWidth != nextProps.accordionWidth)
            this.recreateElements();
    },
    recreateElements() {
        setTimeout(this.refreshNewContent, 50);
    },
    refreshNewContent() {
        this.initElements();
    },
    initElements() {
        var elements = [];
        var i;
        var item;

        for (i=0; i<this.props.dataProvider.length; i++) {
            item = this.props.dataProvider[i];
            elements.push(<SoundItemRenderer accordionWidth={this.props.accordionWidth} index={i} key={'audioBrowser' + item.title + '_' + Math.random()} dispatch={this.props.dispatch} value={item}/>);
        }

        this.setState({
            elements
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.elements != nextState.elements || this.props.categoriesVisible != newProps.categoriesVisible || this.props.windowHeight != newProps.windowHeight || this.props.dataProvider != newProps.dataProvider)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        const buttonsHolderHeight = properties.BROWSER_BUTTON_HEIGHT;
        var categoriesHeight = 0;
        var topPosition = buttonsHolderHeight;
        const bottomPadding = 8;
        var topPadding = properties.CATEGORY_SELECTOR_GAP;

        if (this.props.categoriesVisible == true) {
            categoriesHeight = properties.CATEGORY_SELECTOR_HEIGHT;
            topPosition = topPosition + categoriesHeight;
            topPadding = 0;
        } else
            topPosition = topPosition + properties.MY_MEDIA_FILES_GAP;

        topPosition = topPosition + topPadding;

        if (this.props.showUploadButton)
            topPosition = topPosition + 50;

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.height - topPosition - bottomPadding;
        componentProperties.top = topPosition;
        componentProperties.displayState = 'block';
        componentProperties.elements = this.state.elements;
        componentProperties.scrollHeight = (properties.SOUND_ITEM_HEIGHT + properties.SOUND_ITEMS_GAP) * this.state.elements.length;

        return (
            <ScrollableComponent componentProperties={componentProperties}/>
        );
    }
});

export const StorySoundsBrowserContent = React.createClass({
    getInitialState() {
        return {
            isMyMediaFilesCallDone: false,
        };
    },
    getClipartModel () {
        const clipartModel = storeManager.getState().music.soundClipartModel;
        return clipartModel;
    },
    getMySoundsCategories() {
        var dataProvider = [];

        dataProvider.push(locales.getCaption('UploadedSounds', 'music'));
        dataProvider.push(locales.getCaption('RecordedSounds', 'music'));

        return dataProvider;
    },
    getSelectorDataProvider (type) {
        const clipartModel = this.getClipartModel();

        if (!clipartModel)
            return [];

        const clipartModelItems = clipartModel.items;
        var dataProvider = [];
        var i;

        if (type == 'main') {
            dataProvider.push(clipartModelItems[0].title);
            dataProvider.push(clipartModelItems[1].title);
        } else {
            var mainIndex = 0;

            if (mainIndex >= 0) {
            } else
                mainIndex = 0;

            const itemsObject = clipartModelItems[mainIndex];

            if (itemsObject == undefined)
                return dataProvider;

            const subcategoryItems = itemsObject.items;

            for (i = 0; i < subcategoryItems.length; i++) {
                dataProvider.push(subcategoryItems[i].title);
            }
        }

        return dataProvider;
    },
    onUpload(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        window.parent.postMessage('openUploader', '*');
    },
    onMouseIn () {
        var button = document.getElementById('uploadButton');
        hoverManager.show(button, 'uploadButton');
    },
    onMouseOut () {
        hoverManager.hide();
    },
    getSelectedIndex (type) {
        var index;

        if (type == 'main') {
            index = this.props.mainAudioCategoryIndex;
        } else {
            index = this.props.secondAudioCategoryIndex;
        }

        if (index == undefined || isNaN(index))
            index = 0;

        return index;
    },
    getMusicDataProvider () {
        const clipartModel = this.getClipartModel()

        if (!clipartModel)
            return [];

        const clipartModelItems = clipartModel.items;

        if (clipartModelItems == undefined)
            return [];

        const mainIndex = this.getSelectedIndex('main');
        const secondIndex = this.getSelectedIndex('second');
        const subcategoryItems = clipartModelItems[mainIndex].items;

        if (subcategoryItems == undefined)
            return [];

        var dataProvider = [];
        const contentItems = subcategoryItems[secondIndex].items;
        var i;

        for (i = 0; i < contentItems.length; i++) {
            dataProvider.push(contentItems[i]);
        }

        return dataProvider;
    },
    filterMySounds(dataProvider) {
        var category = this.getSelectedIndex('second');
        var i;
        var array = [];

        for (i=0; i<dataProvider.length; i++) {
            if (category == 1) {// recorded sounds
                if (dataProvider[i].isRecordedSound)
                    array.push(dataProvider[i]);
            } else {
                if (!dataProvider[i].isRecordedSound)
                    array.push(dataProvider[i]);
            }
        }

        return array;
    },
    getMySoundsDataProvider () {
        const dataProvider = this.props.mediaFilesDataProvider;

        if (dataProvider && dataProvider.soundsDataProvider && dataProvider.soundsDataProvider.length > 0)
            return this.filterMySounds(dataProvider.soundsDataProvider);
        else {
            if (this.state.isMyMediaFilesCallDone == true)
                return [];

            setTimeout(this.loadData, 2);

            return [];
        }
    },
    loadData() {
        if (configuration.LOAD_LOCAL == true) {
            // FOR TEST
            this.props.dispatch(setMediaFilesDataProvider({imagesDataProvider: populateMediaFilesUtils.getImagesDataProviderForTest(), soundsDataProvider: populateMediaFilesUtils.getSoundsDataProviderForTest()}));
        } else {
            this.setState({isMyMediaFilesCallDone: true});
            apiServiceUtils.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
        }
    },
    loadMyMediaFiles() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    parseMediaItems (items) {
        populateMediaFilesUtils.parseMediaItems(items, this.props.dispatch, true);
        this.setState({isMyMediaFilesCallDone: false});
    },
    category() {
        if (this.props.musicContentIndex == undefined || this.props.musicContentIndex == 0)
            return 0;
        else
            return 1;
    },
    getContentDataProvider () {
        if (this.category() == 0)
            return this.getMusicDataProvider();
        else
            return this.getMySoundsDataProvider();
    },
    isCategorySelectorVisible() {
        if (this.category() == 0)
            return true;
        else
            return false;
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const target = e.target;
        if (this.hasParentWithId(target, 'categorySelector', 7) == false) {
            this.props.dispatch(expandAudioList(false, 'all'));
        }

        setTimeout(this.refreshView, 5);
    },
    hasParentWithId(target, parentId, level) {
        if (target.id == parentId)
            return true;

        var i;

        for (i=0; i<level; i++) {
            if (target.parentNode == undefined) {
                return false;
            } else {
                target = target.parentNode;

                if (target.id == parentId)
                    return true;
            }
        }

        return false;
    },
    refreshView() {
        this.forceUpdate();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.musicContentIndex != newProps.musicContentIndex || this.props.secondAudioCategoryIndex != newProps.secondAudioCategoryIndex || this.props.mainAudioCategoryIndex != newProps.mainAudioCategoryIndex || this.props.secondAudioCategoryIsExpanded != newProps.secondAudioCategoryIsExpanded || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.mainAudioCategoryIsExpanded != newProps.mainAudioCategoryIsExpanded)
            return true;
        else
            return false;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: this.props.top,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        const buttonsHolderStyle = {
            position: 'absolute',
            top: 0
        };

        const selectorTopPosition = properties.BROWSER_BUTTON_HEIGHT;
        const height = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - 2 * properties.BROWSER_BUTTON_HEIGHT - 2 * properties.AUDIO_EDITOR_BUTTON_GAP - properties.CLIPART_BUTTON_HEIGHT;

        var uploadButton;
        var showUploadButton = !platformDetection.isIOSApp() && this.props.musicContentIndex == 1 && (!this.props.secondAudioCategoryIndex || this.props.secondAudioCategoryIndex == 0);

        if (showUploadButton) {
            if (platformDetection.isIOS()) {
                var uploadIconStyle = {
                    position: 'absolute',
                    top: 85,
                    left: properties.BROWSER_WIDTH/2 - 42/2,
                    color: '#2DE102'
                };

                uploadButton = <i id='uploadButton' style={uploadIconStyle} className="fa fa-plus-circle fa-3x" onMouseDown={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}/>;
            } else {
                var uploadButtonStyle = {
                    position: 'absolute',
                    top: 85,
                    left: properties.BROWSER_WIDTH/2 - 42/2,
                    margin: 0,
                    padding: 0,
                    boxSizing: 'initial',
                    fontSize: 'initial',
                    borderStyle: 'none',
                    width: 41,
                    height: 48,
                    background: 'none'
                };

                var uploadIconPlusStyle = {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    color: '#2DE102'
                };

                uploadButton =
                    <button id='uploadButton' aria-label={locales.getCaption('UploadHover', 'myFiles')} style={uploadButtonStyle} onClick={this.onUpload} onTouchStart={this.onUpload} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                        <i style={uploadIconPlusStyle} className="fa fa-plus-circle fa-3x"/>
                    </button>;
            }
        }

        var dataProvider = this.props.musicContentIndex == 1 ? this.getMySoundsCategories() : this.getSelectorDataProvider('second');

        return (
            <div ref='audioBrowser' style={menuStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <div style={buttonsHolderStyle}>
                        <Button accordionWidth={this.props.accordionWidth} type={'second'} index={0} category={this.props.musicContentIndex} dispatch={this.props.dispatch}/>
                        <Button accordionWidth={this.props.accordionWidth} type={'second'} index={1} category={this.props.musicContentIndex} dispatch={this.props.dispatch}/>
                    </div>
                    <AudioCategorySelectorNew top={selectorTopPosition} accordionWidth={this.props.accordionWidth} type={'second'} isAdvancedMenu={true} visible={true} isExpanded={this.props.secondAudioCategoryIsExpanded} selectedIndex={this.getSelectedIndex('second')} dataProvider={dataProvider} dispatch={this.props.dispatch}/>
                    {uploadButton}
                    <AudioList accordionWidth={this.props.accordionWidth} categoriesVisible={true} height={height} showUploadButton={showUploadButton} windowHeight={this.props.windowHeight} dispatch={this.props.dispatch} dataProvider={this.getContentDataProvider()}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();

    const mainAudioCategoryIsExpanded = state.menu.mainAudioCategoryIsExpanded;
    const secondAudioCategoryIsExpanded = state.menu.secondAudioCategoryIsExpanded;
    const mainAudioCategoryIndex = state.music.mainAudioCategoryIndex;
    const secondAudioCategoryIndex = state.music.secondAudioCategoryIndex;
    const musicContentIndex = state.music.musicContentIndex;
    const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;

    return {
        mainAudioCategoryIsExpanded,
        secondAudioCategoryIsExpanded,
        mainAudioCategoryIndex,
        secondAudioCategoryIndex,
        musicContentIndex,
        mediaFilesDataProvider
    };
}

export const StorySoundsBrowser = connect(mapStateToProps)(StorySoundsBrowserContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/StorySoundsBrowser.js
 **/